import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ZoomIn2"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10.5 1.25C5.39139 1.25 1.25 5.39139 1.25 10.5C1.25 15.6086 5.39139 19.75 10.5 19.75C12.7843 19.75 14.8752 18.922 16.489 17.5497L20.8531 21.9138L21.9138 20.8531L17.5497 16.489C18.922 14.8752 19.75 12.7843 19.75 10.5C19.75 5.39139 15.6086 1.25 10.5 1.25ZM2.75 10.5C2.75 6.21981 6.21981 2.75 10.5 2.75C14.7802 2.75 18.25 6.21981 18.25 10.5C18.25 14.7802 14.7802 18.25 10.5 18.25C6.21981 18.25 2.75 14.7802 2.75 10.5ZM11.2498 14.249V11.2529L14.2505 11.249L14.2485 9.74902L11.2498 9.75293V6.74902H9.74976V9.75488L6.75635 9.75878L6.7583 11.2588L9.74976 11.2549V14.249H11.2498Z"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ZoomIn2.vue"]]);
